import Auth from './auth.js'
import Api from './lib/api.js';
import DlgPrivacy from './lib/privacy.js'
import IVPLoader from './lib/loader.js'

document.addEventListener("DOMContentLoaded",async()=>{

    document.querySelector("#sidebar-menu .operators").classList.add("active")
    document.querySelector(".navbar-header .breadcrumb").append($(`<li class="breadcrumb-item active">Operatori</li>`)[0])
    
    IVPLoader.Show()

    await Auth.Init()

    if (Auth.user.privacy_accepted == false)
        await DlgPrivacy.EnsureAccepted()

    // Default Datatable
    let resp = await Api.GetOperators()
    let btb = $('#basic-datatable').DataTable({
        buttons: [
            'copy', 'excel', 'pdf'

        ],
        "pageLength": 50,
        "language": {
            "paginate": {
                "previous": "<i class='mdi mdi-chevron-left'>",
                "next": "<i class='mdi mdi-chevron-right'>"
            },
            processing:     "Elaborazione dati...",
            search:         "Ricerca&nbsp;:",
            lengthMenu:    "Visualizza _MENU_ record",
            info:           "Visualizzati da _START_ a _END_ di _TOTAL_ record",
            infoEmpty:      "Nessun record in archivio",
            infoFiltered:   "(trovati su _MAX_ in totale)",
            infoPostFix:    "",
            loadingRecords: "Caricamento dati...",
            zeroRecords:    "Nessun record",
            emptyTable:     "Archivio vuoto",
            sortAscending:  ": activer pour trier la colonne par ordre croissant",
            sortDescending: ": activer pour trier la colonne par ordre décroissant"
        },

        columns: [                        
            { title: 'Nome', data: 'login' },
            { title: ' ', data: '' },
        ],
        
        columnDefs: [
            {   
                targets: [-1],
                width: 100,
                render: function (data, type, row) {
                    return "<button type='button' class='btnEdit btn btn-outline-secondary btn-sm'>Modifica</button>";   
                },
                
            },
        ],
        data: resp,
       
    });

    let fnEdit = ()=> {
        $("#basic-datatable .btnEdit").off('click')
        $("#basic-datatable .btnEdit").click((e)=>{
            let tr = btb.row(e.target.closest('tr'))
            document.location.href = "operator.html?id="+tr.data().id
            console.log(tr.data())
        })
    }

    fnEdit()    
    btb.on( 'draw init.dt', fnEdit)
    
    $(".btnAdd").click((e)=>{        
        document.location.href = "operator.html?id="+(-1)
        console.log(tr.data())
    })
    

    IVPLoader.Remove()
})